// extracted by mini-css-extract-plugin
export var layoutContainer = "_bo-0";
export var layoutContainerNoRounding = "_bo-6";
export var layoutContainerOpen = "_bo-5";
export var layoutContainerResizing = "_bo-1";
export var mainContent = "_bo-2";
export var resizeDivider = "_bo-3";
export var slidePanel = "_bo-4";